import { useRef } from 'react'
import isEqual from 'lodash/isEqual'

/**
 * In some cases dependencies of useMemo are object references that need deep comparisons.
 * @param memoFn useMemo function that has returned value.
 * @param key useMemo dependencies; used in deep comparison.
 * @returns Current ref value; cached or updated.
 */
export function useDeepMemo<TValue>(memoFn: () => TValue, key: unknown[]): TValue {
  const ref = useRef<{ key: unknown[]; value: TValue }>()

  if (!ref.current || !isEqual(key, ref.current.key)) {
    ref.current = { key, value: memoFn() }
  }

  return ref.current.value
}
